var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from "axios";
import { ResponseError } from "./error";
import { getToken } from "./config";
import { params as paramsSerialize } from "@/utils/url/param";
export function request(url, config) {
    if (config === void 0) { config = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, params, body, headers, token, requestParams, requestHeaders, _b, data, error, responseHeaders;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = config.method, method = _a === void 0 ? "get" : _a, params = config.params, body = config.body, headers = config.headers, token = config.token, requestParams = __rest(config, ["method", "params", "body", "headers", "token"]);
                    requestHeaders = __assign({}, headers);
                    if (body && body instanceof FormData) {
                        requestHeaders["Content-Type"] = "multipart/form-data";
                    }
                    return [4 /*yield*/, axios(__assign({ method: method, url: url, params: token === false
                                ? params
                                : __assign(__assign({}, params), { "access-token": getToken() }), paramsSerializer: function (params) {
                                return paramsSerialize(params);
                            }, data: body, responseType: "json" }, requestParams))
                            .then(function (response) {
                            return {
                                data: response.data,
                                headers: response.headers,
                            };
                        })
                            .catch(function (error) {
                            return {
                                data: error.response.data,
                                status: error.response.status,
                                error: new ResponseError(error.response),
                            };
                        })];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error, responseHeaders = _b.headers;
                    return [2 /*return*/, {
                            data: data,
                            error: error,
                            headers: responseHeaders,
                        }];
            }
        });
    });
}
export function requestFile(url, config, onDownloadProgress) {
    if (config === void 0) { config = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, params, body, headers, token, requestParams, requestHeaders, _b, data, error, responseHeaders;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = config.method, method = _a === void 0 ? "get" : _a, params = config.params, body = config.body, headers = config.headers, token = config.token, requestParams = __rest(config, ["method", "params", "body", "headers", "token"]);
                    requestHeaders = __assign({}, headers);
                    if (body && body instanceof FormData) {
                        requestHeaders["Content-Type"] = "multipart/form-data";
                    }
                    return [4 /*yield*/, axios(__assign({ method: method, url: url, params: token === false
                                ? params
                                : __assign(__assign({}, params), { "access-token": getToken() }), paramsSerializer: function (params) {
                                return paramsSerialize(params);
                            }, data: body, responseType: "blob", onDownloadProgress: onDownloadProgress }, requestParams))
                            .then(function (response) {
                            return __assign({ data: response.data, headers: response.headers }, response);
                        })
                            .catch(function (error) {
                            return {
                                data: error.response.data,
                                status: error.response.status,
                                error: new ResponseError(error.response),
                            };
                        })];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error, responseHeaders = _b.headers;
                    return [2 /*return*/, {
                            data: data,
                            error: error,
                            headers: responseHeaders,
                        }];
            }
        });
    });
}
